import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SelectTenant from './SelectTenant';
import { Modal } from 'antd';
import s from './style.m.less';

@inject('store')
@observer
class Tenant extends Component {
    onInputChange = (value) => {
        const {
            store: { login }
        } = this.props;
        login.setKeyWord(value);
    };

    onSearch = () => {
        const {
            store: { login }
        } = this.props;
        let showList = [];
        if (login.activeIdentity === 'admin') {
            showList = login.tenantList?.adminTenants?.filter((item) => {
                return item.tenant_name.indexOf(login.key_word) > -1;
            });
        } else {
            showList = login.tenantList?.studentTenants?.filter((item) => {
                return item.tenant_name.indexOf(login.key_word) > -1;
            });
        }
        login.setShowTenantList(showList);
    };

    componentDidMount() {
        const {
            store: { login }
        } = this.props;
        login.fetchList();
        login.getUserInfo();
    }

    goLogin = () => {
        window.location.href = '/login';
    };

    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <Modal
                footer={null}
                destroyOnClose={true}
                open={login.switchTenant}
                width={920}
                bodyStyle={{ padding: 0 }}
                onCancel={() => {
                    login.setSwitchTenant(false);
                }}
            >
                <div className={s.content_main}>
                    <div
                        style={{
                            display: 'flex',
                            height: '70px',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(0,0,0,0.06)'
                        }}
                    >
                        <div style={{ fontSize: '14px', color: '#999' }}>
                            <span style={{ fontSize: '18px', color: '#333', fontWeight: '500' }}>选择组织</span>（账号
                            {login.userInfo.nick_name}
                            绑定了以下租户，请选择进入学员端/管理端）
                        </div>
                    </div>
                    <SelectTenant />
                </div>
            </Modal>
        );
    }
}

export default Tenant;
